import {
  GET_KEYMANS_YESTERDAY_SUCCESS,
  GET_KEYMANS_TOTAL_SUCCESS,
} from "../../constants/action-types"

const initialState = {
  keymansTotal: " - ",
  corporationsTotal: " - ",
  keymanCountYstd: " - ",
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_KEYMANS_YESTERDAY_SUCCESS:
      return {
        ...state,
        keymanCountYstd: action.payload.count,
      }
    case GET_KEYMANS_TOTAL_SUCCESS:
      return {
        ...state,
        corporationsTotal: action.payload.corporationsTotal,
        keymansTotal: action.payload.keymansTotal,
      }
    default:
      return state
  }
}
